








































































































import { Component, Vue } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import { eventBus } from '@/main';
import { APP_CONFIG } from '@/config/app-config';
import creditServices from '@/services/credit-services';
const numeral = require('numeral');

@Component({
    components: {
        Loading
    }
})
export default class Withdrawal extends Vue {
    private withdrawalModel = {
        withDrawValue: '0',
        bank: '',
        bankOwner: '',
        bankNumber: '',
        description: ''
    };
    private isLoading = false;

    get customerInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].customerInfo || {};
    }

    private setWithdrawAll() {
        const wallet = this.customerInfo.Wallet || 0;
        if (wallet > 0) {
            this.withdrawalModel.withDrawValue = wallet.toLocaleString('en-US');
        }
    }

    private async withDrawal() {
        try {
            const isValid = await (this.$refs['observer'] as any).validate();
            if (isValid) {
                const amount = numeral(this.withdrawalModel.withDrawValue).value();
                if ((this.customerInfo.Wallet || 0) < 50000) {
                    Vue.notify({
                        group: 'foo',
                        type: 'error',
                        title: 'Thông báo!',
                        text: 'Không thể tạo yêu cầu rút tiền. Số dư ví phải từ 50,000đ trở lên.',
                    });
                    return;
                }
                if ((this.customerInfo.Wallet || 0) < amount) {
                    Vue.notify({
                        group: 'foo',
                        type: 'error',
                        title: 'Thông báo!',
                        text: 'Không thể rút nhiều hơn số dư ví hiện tại.',
                    });
                    return;
                }

                this.isLoading = true;

                const dataRequest = {
                    Amount: amount,
                    Bank: this.withdrawalModel.bank,
                    BankAccountNumber: this.withdrawalModel.bankNumber,
                    BankAccountName: this.withdrawalModel.bankOwner,
                    Note: this.withdrawalModel.description
                };

                const result = await creditServices.submitWithdrawal(dataRequest);

                if (result && result.status === 200 && result.data.message === 'Success') {
                    Vue.notify({
                        group: 'foo',
                        type: 'success',
                        title: 'Thông báo!',
                        text: 'Tạo lệnh rút tiền thành công!',
                    });
                    this.withdrawalModel = {
                        withDrawValue: '0',
                        bank: '',
                        bankOwner: '',
                        bankNumber: '',
                        description: ''
                    };
                    eventBus.$emit(APP_CONFIG.eventBusAction.reloadWithdrawalHistories);
                } else {
                    Vue.notify({
                        group: 'foo',
                        type: 'error',
                        title: 'Thông báo!',
                        text: `Tạo lệnh rút tiền thất bại! ${result && result.data ? result.data.error : ''}`,
                    });
                }
                this.isLoading = false;
            }
        } catch {
            this.isLoading = false;
        }
    }
}
